const statusTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Inativo', class: 'bg-danger' },
    1: { label: 'Ativo', class: 'bg-success' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const tipoUsuarioTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    2: { label: 'Admin', class: 'bg-dark' },
    3: { label: 'Normal', class: 'bg-primary' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const statusSincronizacaoLabel = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Aguardando', class: 'bg-yellow' },
    1: { label: 'Em Andamento', class: 'bg-teal' },
    2: { label: 'Finalizado', class: 'bg-success' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

export { statusTranslate, tipoUsuarioTranslate, statusSincronizacaoLabel }
